__turbopack_context__.v({
  "highlight": "d-n2WW_highlight",
  "highlight__controls": "d-n2WW_highlight__controls",
  "highlight__controls_kabob": "d-n2WW_highlight__controls_kabob",
  "highlight__video_playing": "d-n2WW_highlight__video_playing",
  "highlight_badge": "d-n2WW_highlight_badge",
  "highlight_block__description": "d-n2WW_highlight_block__description",
  "highlight_explore_the_show": "d-n2WW_highlight_explore_the_show",
  "highlight_first_title": "d-n2WW_highlight_first_title",
  "highlight_logo": "d-n2WW_highlight_logo",
  "highlight_poster": "d-n2WW_highlight_poster",
  "highlight_poster__image": "d-n2WW_highlight_poster__image",
  "highlight_second_title": "d-n2WW_highlight_second_title",
  "highlight_summary": "d-n2WW_highlight_summary",
  "highlight_text": "d-n2WW_highlight_text",
});
